import type { ContentEntity } from "shared/schema";
import { useState } from "react";
import { getRandomExcept } from "shelving";
import { CREATE_COMMENT } from "shared/api";
import { Form, Icon, SubmitButton, TextAreaField } from "shared/react";
import { COMMENT_FORM_SCHEMA } from "shared/schema";
import { callAPI } from "../util/api.js";

/** Comment form is single-line because it only has one field. */
export function CommentForm({ target, thread }: { target: ContentEntity; thread: string | null }): React.ReactElement {
	const [key, setKey] = useState(0);
	return (
		<Form
			key={key}
			schema={COMMENT_FORM_SCHEMA}
			onSubmit={async v => {
				await callAPI(CREATE_COMMENT, { target, thread, ...v });
				setKey(getRandomExcept); // Reset the form by randomly changing the key to anything except its previous number.
			}}
			mods="flex-row"
		>
			<TextAreaField name="content" />
			<SubmitButton>
				<Icon icon="reply" title="Post comment" />
			</SubmitButton>
		</Form>
	);
}
